import React from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

/**
 * Level-selection tile.
 *
 * Renders as a React-Router `<Link>` when `disabled` is `false`; falls back to a
 * disabled `<button>` otherwise.  Keeps the exact same visual layout for both
 * states so the grid doesn’t jump.
 *
 * @param {object}  props
 * @param {string}  props.to                 Destination path for the router (ignored when disabled).
 * @param {string}  props.title              Bold headline shown inside the tile.
 * @param {string}  props.desc               Short description under the headline.
 * * @param {object}  props.img             img

 * @returns {JSX.Element}
 */
export default function LevelTile({
  to,
  title,
  desc,
  img = null,
  onClick,
  disabled = false,
}) {
  const { t } = useTranslation();

  const classes =
    "grid grid-flow-row grid-cols-2 gap-2 p-2 border-2 border-tertiary rounded-xl";

  if (disabled) {
    return (
      <button type="button" className={classes + " opacity-70"} disabled>
        <div className="flex flex-col gap-0 items-start justify-start text-start">
          <p className="subtitle-text">{title}</p>
          <p className="text-greyscale-3">{desc}</p>
        </div>
        <div className="flex flex-col gap-1 items-end justify-between">
          <div className="w-full h-16 flex flex-col items-center justify-center">
            {img}
          </div>
          <div className="small-primary-button opacity-60">
            {t("levelSelection.notSupportedCta")}
          </div>
        </div>
      </button>
    );
  }

  return (
    <Link to={to} className={classes} onClick={onClick}>
      <div className="flex flex-col gap-0 items-start justify-start text-start">
        <p className="subtitle-text">{title}</p>
        <p className="text-greyscale-3">{desc}</p>
      </div>
      <div className="flex flex-col gap-1 items-end justify-between">
        <div className="w-full h-16 flex flex-col items-center justify-center">
          {img}
        </div>
        <div className="small-primary-button">
          {t("levelSelection.continue")}
        </div>
      </div>
    </Link>
  );
}
